import React from "react";

export const LogoutIcon = (props) => {
  return (
    <svg viewBox="0 0 20 18" fill="none" {...props}>
      <path
        d="M10.0019 0.00268555C9.45188 0.00268555 9.00188 0.452686 9.00188 1.00269V9.00269C9.00188 9.55269 9.45188 10.0027 10.0019 10.0027C10.5519 10.0027 11.0019 9.55269 11.0019 9.00269V1.00269C11.0019 0.452686 10.5519 0.00268555 10.0019 0.00268555ZM15.1419 2.86269C14.7519 3.25269 14.7619 3.86269 15.1319 4.25269C16.2619 5.45269 16.9619 7.05269 17.0019 8.82269C17.0919 12.6527 13.9219 15.9527 10.0919 15.9927C6.18188 16.0527 3.00188 12.9027 3.00188 9.00269C3.00188 7.16269 3.71188 5.49269 4.87188 4.24269C5.24188 3.85269 5.24188 3.24269 4.86188 2.86269C4.46188 2.46269 3.81188 2.47269 3.43188 2.88269C1.98188 4.42269 1.07188 6.47269 1.00188 8.74269C0.861884 13.6227 4.83188 17.8427 9.71188 17.9927C14.8119 18.1527 19.0019 14.0627 19.0019 8.99269C19.0019 6.62269 18.0819 4.48269 16.5819 2.88269C16.2019 2.47269 15.5419 2.46269 15.1419 2.86269Z"
        fill={!!props.fill ? props.fill : "#F0AF42"}
      />
    </svg>
  );
};
